export interface DealFormData {
  empresaNome: string
  cnpj: string
  site: string
  contato: string
  telefone: string
  email: string
  segmento: string
  plataforma: string
  modelo: string
  faturamento: string
  dealNome: string
  valor: number
  probabilidade: number
  observacoes: string
}

export interface RocketDealsFormProps {
  open: boolean
  onClose: () => void
  onSuccess: () => void
}

export interface FieldError {
  field: string
  message: string
}

export const SEGMENTOS = [
  'Alimentação', 'Saúde', 'Educação', 'Tecnologia', 'Varejo',
  'Serviços', 'Indústria', 'Construção', 'Imobiliário', 'Financeiro',
  'Transporte', 'Agronegócio', 'Moda', 'Turismo', 'Outro',
]

export const PLATAFORMAS = [
  'Shopify', 'Netshoes', 'Mercado Livre', 'Magazine Luiza',
  'Amazon', 'Facebook Ads', 'Google Ads', 'TikTok Ads',
  'Instagram', 'Site Próprio', 'Outra',
]

export const MODELOS = ['B2B', 'B2C', 'B2B e B2C', 'Marketplace']

export const initialForm: DealFormData = {
  empresaNome: '',
  cnpj: '',
  site: '',
  contato: '',
  telefone: '',
  email: '',
  segmento: '',
  plataforma: '',
  modelo: '',
  faturamento: '',
  dealNome: '',
  valor: 0,
  probabilidade: 10,
  observacoes: '',
}
